var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNurturingImg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.417 8.58594C15.6592 8.23438 18.1982 5.65625 18.5107 2.375H18.2373C15.2295 2.375 12.6904 4.32812 11.7139 6.98438C11.4014 6.32031 10.9717 5.69531 10.5029 5.14844C11.9873 2.375 14.8779 0.5 18.2373 0.5H19.1748C19.8389 0.5 20.4248 1.08594 20.4248 1.75C20.4248 6.20312 17.1045 9.875 12.8076 10.4219C12.7295 9.79688 12.6123 9.21094 12.417 8.58594ZM2.2998 4.875V5.5C2.2998 9.32812 5.34668 12.375 9.1748 12.375H9.4873V11.75C9.4873 7.96094 6.40137 4.875 2.6123 4.875H2.2998ZM11.3623 11.75V12.375V14.25V19.5625C11.3623 20.1094 10.9326 20.5 10.4248 20.5C9.87793 20.5 9.4873 20.1094 9.4873 19.5625V14.25H9.1748C4.33105 14.25 0.424805 10.3438 0.424805 5.5V4.25C0.424805 3.58594 0.97168 3 1.6748 3H2.6123C7.41699 3 11.3623 6.94531 11.3623 11.75Z",
    fill: "#2AAD8F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNurturingImg);
export default __webpack_public_path__ + "static/media/nurturing-img.3c986be1c3ab87c19a0f15f9360c62aa.svg";
export { ForwardRef as ReactComponent };